import { IonFooter } from '@ionic/react';

export const PageFooter: React.FC<{shadow?: boolean, children: React.ReactNode}> = ({ shadow, children }) => {

    const paddingBottom = 'var(--ion-safe-area-bottom)';
    const boxShadow = shadow ? '0 0 4px 1px rgba(0, 0, 0, 0.15)' : undefined;

    return (
        <IonFooter style={{paddingBottom, boxShadow}}>
            {children}
        </IonFooter>
    );
};
